const VEHICLES_SOLD_MONTHLY = [
	{ value: '1', text: '1 - 14' },
	{ value: '2', text: '15 - 29' },
	{ value: '3', text: '30 - 100' },
	{ value: '4', text: '100+' },
	{ value: '5', text: 'Unknown' },
];

export default VEHICLES_SOLD_MONTHLY;
